<template>
    <modal @close="clearSelectedItem" dialog="modal-lg" class="dark-top" :footer="false">
        <div slot="title">
            <h2>Resource details</h2>
            <h3 v-if="getSelectedItem">{{ getSelectedItem.name }}</h3>
        </div>

        <div slot="body">
            <tabs>
                <!-- <tab name="Overview">
                    <overview></overview>
                </tab> -->
                <tab name="Details">
                    <resource-edit></resource-edit>
                </tab>
            </tabs>
        </div>
    </modal>
</template>
   
<script>
    import { mapActions, mapGetters } from 'vuex'
    import Modal from './Modal'
    import Overview from '@/components/inventory/resources/ResourceOverview'
    import ResourceEdit from '@/components/inventory/resources/ResourceEdit'

    export default {
        methods: {
            ...mapActions([
                'clearSelectedItem'
            ]),
        },
        computed: {
            ...mapGetters([
                'getSelectedItem',
            ])
        },
        components: {
            Modal,
            ResourceEdit,
            Overview,
        }
    }
</script>


// WEBPACK FOOTER //
// ResourceView.vue?86189722